import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import 'vuetify/styles'

import App from '@/App.vue'
import router from '@/router'

const oishausgmochtTheme = {
  dark: true,
  colors: {
    background: '#231F20',
    surface: '#1D1D1B',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#424242',
    'on-surface-variant': '#EEEEEE',
    // primary: '#1867C0',
    // 'primary-darken-1': '#1F5592',
    primary: '#FCC707',
    'primary-darken-1': '#5d4c19',
    secondary: '#48A9A6',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#1D1D1B',
    success: '#4CAF50',
    warning: '#FB8C00'
  },
  variables: {
    'border-color': '#FFCC00',
    'border-opacity': 0.12,
    'high-emphasis-opacity': 0.87,
    'medium-emphasis-opacity': 0.6,
    'disabled-opacity': 0.38,
    'idle-opacity': 0.04,
    'hover-opacity': 0.04,
    'focus-opacity': 0.12,
    'selected-opacity': 0.08,
    'activated-opacity': 0.12,
    'pressed-opacity': 0.12,
    'dragged-opacity': 0.08,
    'theme-kbd': '#212529',
    'theme-on-kbd': '#FFFFFF',
    'theme-code': '#F5F5F5',
    'theme-on-code': '#000000'
  }
}

const app = createApp(App)
const vuetify = createVuetify({
  theme: {
    defaultTheme: 'oishausgmochtTheme',
    themes: {
      oishausgmochtTheme
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  }
})

app.use(router)
app.use(createPinia())
app.use(vuetify)
app.mount('#app')
